import { IPageAddCallback, api } from "./index";
import { message, Modal } from "antd";
import { lang } from "../context";
import events from "../context/events";
import { ActionFnEnum, ActionType } from "../types";
const { confirm } = Modal;

const remove: IPageAddCallback = (props, isAllow) => {
  const { data, remove, setData } = props;
  return [
    {
      children: lang("common.list-remove"),
      callbackOrModal: () => {
        confirm({
          title: lang("remove-recent-title"),
          content: lang("remove-recent-content"),
          okText: lang("common.confirm"),
          cancelText: lang("common.cancel"),
          onOk() {
            api.page.recent.remove(data.id).then((res) => {
              if (res) {
                message.success(lang("common.remove-success"));
                setData({
                  type: ActionFnEnum.REMOVE,
                  id: data.id,
                  actionType: ActionType.Page
                } as any);
              } else {
                message.error(lang("common.fail"));
              }
            });
          }
        });
      },
      isAllow,
      type: "delete",
      icon: "pc_yundoc_yichu",
      splitCode: 3
    }
  ];
};

export default remove;
